import React, { useState, forwardRef, useEffect } from 'react'
import { useTbViewStore } from '@vt/hooks'
import { pick } from 'lodash-es'
import { LoadingOverlay } from '@mantine/core'
import NodeContent from './nodeContent'
import FormContent from './formContent'

const Content = function () {
  const [showContent, setShowContent] = useState('node')
  const [overlayVisible, setOverlayVisible] = useState(false)
  const { setRefreshStatus } = useTbViewStore((state) =>
    pick(state, ['setRefreshStatus'])
  )
  useEffect(() => {
    if (setRefreshStatus) {
      setRefreshStatus(false)
    }
  }, [])
  return (
    <div>
      <LoadingOverlay
        className="fixed inset-0 h-full w-full"
        visible={overlayVisible}
        overlayBlur={2}
      />
      {showContent === 'node' ? (
        <NodeContent
          setShowContent={setShowContent}
          setOverlayVisible={setOverlayVisible}
        />
      ) : (
        <FormContent
          setShowContent={setShowContent}
          setOverlayVisible={setOverlayVisible}
        />
      )}
    </div>
  )
}

export default forwardRef(Content)
